import React from 'react';

function Homebody3() {
  return (
    <div>
      <section className="process-section padding">
        <div className="map-pattern" />
        <div className="container">
          <div className="section-heading text-center mb-40">

            <h2 className="text-anim" data-effect="fade-in-right" data-split="char" data-delay="0.3" data-duration={1}>Our <span className="hl">IT Solutions</span></h2>
            <p className="text-anim" data-effect="fade-in-bottom" data-ease="power4.out">Our IT company specializes in providing innovative technology solutions <br />to enhance your business operations.</p>
          </div>
          <div className="row process-wrapper gy-lg-0 gy-4">
            <div className="col-lg-3 col-md-6">
              <div className="process-item wow fade-in-bottom" data-wow-delay="100ms">
                <div className="process-icon">
                  <i className="fa fa-laptop-code" />
                  <span>1</span>
                </div>
                <div className="process-content">
                  <h3>Software Development</h3>
                  <p>We create custom software solutions tailored to your business needs.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="process-item wow fade-in-bottom" data-wow-delay="300ms">
                <div className="process-icon">
                  <i className="fa fa-cloud" />
                  <span>2</span>
                </div>
                <div className="process-content">
                  <h3>Cloud Solutions</h3>
                  <p>Our team provides scalable cloud solutions to enhance your operations.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="process-item wow fade-in-bottom" data-wow-delay="500ms">
                <div className="process-icon">
                  <i className="fa fa-shield-alt" />
                  <span>3</span>
                </div>
                <div className="process-content">
                  <h3>Cybersecurity</h3>
                  <p>We ensure your business is protected with our comprehensive security solutions.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="process-item wow fade-in-bottom" data-wow-delay="700ms">
                <div className="process-icon">
                  <i className="fa fa-chart-line" />
                  <span>4</span>
                </div>
                <div className="process-content">
                  <h3>Data Analytics</h3>
                  <p>We provide insights through data analytics to drive your business decisions.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
export default Homebody3;